<template>
  <div class="echart-container">
    <van-empty v-if="empty" description="暂无数据" />
    <div v-else class="echart-content" ref="echart"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      chartNode: null
    }
  },
  watch: {
    'data.loaded'() {
      if (this.data.loaded) {
        this.initEchart()
      }
    }
  },
  computed: {
    empty() {
      return !(this.data.data && this.data.data.length)
    }
  },
  mounted() {
    if (this.data.loaded) {
      this.initEchart()
    }
  },
  methods: {
    initEchart() {
      let el = this.$refs.echart
      if (el) {
        this.chartNode = echarts.init(el)
        let dataList = this.data.data || []
        if (!dataList.length) {
          return
        }
        let xList = dataList.map((item) => {
          return item.time.replace(/-/, '\n')
        })
        let yList = dataList.map((item) => {
          return item.value
        })
        // 绘制图表
        this.setOption(this.chartNode, xList, yList)
      }
    },
    setOption(chart, xList, yList) {
      let startValue = xList.length - 7
      startValue = startValue > 0 ? startValue : 0
      let endValue = xList.length - 1
      endValue = endValue > 0 ? endValue : 0
      var option = {
        dataZoom: [
          {
            type: 'inside',
            startValue: startValue,
            endValue: endValue,
            // zoomLock: true,
            preventDefaultMouseMove: false //禁止canvas上下滑动
          }
        ],
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            label: {
              show: true,
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: { top: '10%', bottom: '20%', right: '5%' },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {}
          },
          // 更改x轴线的颜色
          axisLine: {
            lineStyle: {
              color: '#e6e6e6',
              width: 1 //x轴线的宽度
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: 'rgba(0,0,0,0.5)', //更改坐标轴文字颜色
              fontSize: 10 //更改坐标轴文字大小
            }
          },
          data: xList
        },
        yAxis: {
          show: true,
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {}
          }
        },
        series: [
          {
            data: yList,
            type: 'line',
            symbol: 'circle', //将小圆点改成实心 不写symbol默认空心
            symbolSize: 8, //小圆点的大小
            lineStyle: {
              width: 4,
              color: 'rgb(45,122,252)' //曲线的颜色
            },
            itemStyle: {
              color: 'rgb(45,122,252)', //点的颜色
              borderWidth: 1,
              borderColor: '#fff'
            },
            label: {
              normal: {
                show: true,
                position: 'top',
                fontSize: 10
              }
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(45,122,252,0.3)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(45,122,252,0)' // 区域100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      }
      chart.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
.echart-container {
  width: 100%;
  height: 100%;
  position: relative;

  .echart-content {
    width: 100%;
    height: 100%;
  }
}
</style>
